import { useEffect, useState } from "react";

//helpers
import { buildBreadcrumbs, getInitialBreadCrumbs, observeUrlChanges, patchBreadcrumbWhenContentIdAppears, syncTitleFromInput } from "@/helpers/BreadCrumbs";

//interfaces
import { BREADCRUMB_MENU_SESSION_KEY, BREADCRUMB_SESSION_KEY, IBreadCrumb } from "@/interfaces/IBreadCrumbs";



export const useBreadCrumbs = (menuId?: string) => {
    //get breadcrumbs from session storage when the page loads
    const [breadCrumbs, setBreadCrumbs] = useState<IBreadCrumb[]>(getInitialBreadCrumbs);

    useEffect(() => {
        const updateBreadcrumbs = () => {
            const updatedBreadCrumbs = buildBreadcrumbs(window.location.href, getInitialBreadCrumbs());
            setBreadCrumbs(updatedBreadCrumbs);
            sessionStorage.setItem(BREADCRUMB_SESSION_KEY, JSON.stringify(updatedBreadCrumbs));
        };

        updateBreadcrumbs();
        if (menuId) {sessionStorage.setItem(BREADCRUMB_MENU_SESSION_KEY, menuId);}

        const cleanupTitleSync = syncTitleFromInput(setBreadCrumbs);
        const cleanupObserver = observeUrlChanges(updateBreadcrumbs);

        return () => {
            cleanupTitleSync();
            cleanupObserver();
        };
    }, []);

    
    useEffect(() => {
        //the patching function will return a clean up function so we call it and then clean up.
        const cleanUpPatching = patchBreadcrumbWhenContentIdAppears(breadCrumbs, setBreadCrumbs);
        return cleanUpPatching;
    }, [breadCrumbs]);

    return { breadCrumbs };
};
